import { heroImage } from "@/mocks/naruto";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden">
      <img
        src={heroImage}
        alt="黄昏下宁静的木叶风格忍者村落，金色落日洒满屋顶"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:py-28">
        <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 ring-1 ring-background-50/30">
          <i className="ri-focus-3-line"></i>
          按剧情CP筛选 · 热门角色向分类齐全
        </p>
        <h1 className="mt-6 font-display text-4xl leading-tight text-background-50 md:text-6xl">
          火影同人本子，从你想看的CP开始
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          鸣人CP、佐助CP、鼬樱、卡卡西、鹿丸、我爱罗……点开即可按剧情CP筛选火影同人本子，
          快速定位你想看的故事，让每一次阅读都有清晰的落点。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#categories"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            按CP查找同人本子
          </a>
          <a
            href="#hot"
            className="whitespace-nowrap rounded-md bg-background-50/15 px-7 py-3 text-sm font-medium text-background-50 ring-1 ring-background-50/40 transition-colors hover:bg-background-50/25"
          >
            看热门推荐
          </a>
        </div>

        <dl className="mx-auto mt-12 grid max-w-xl grid-cols-3 gap-4 text-background-50">
          {[
            { num: "6", label: "大CP分类" },
            { num: "1300+", label: "收录作品" },
            { num: "24", label: "剧情标签" },
          ].map((s) => (
            <div key={s.label} className="rounded-lg bg-background-50/10 px-2 py-4 ring-1 ring-background-50/20">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-display text-2xl md:text-3xl">{s.num}</dd>
              <dd className="mt-1 text-xs text-background-50/80">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}